import { useEffect, useState } from "react";
import { msUntilNextStatus, runningStatusAt, type RunningStatus } from "./runningStatus";
import type { SessionDate } from "./types";

/** setTimeout can't wait longer than this (~24.8 days); a later change is
 * picked up on a re-check at that point. */
const MAX_TIMEOUT_MS = 2 ** 31 - 1;

/** The occurrence's running status, moving on by itself at each change (so
 * "Join" lights up ten minutes before the start without a reload). */
export function useRunningStatus(date: SessionDate | null): RunningStatus {
  const start = date?.startDateTime ?? "";
  const duration = date?.duration ?? 0;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!start) return;
    const wait = msUntilNextStatus({ startDateTime: start, duration }, Date.now());
    if (wait === null) return;
    const id = setTimeout(() => setNow(Date.now()), Math.min(Math.max(wait, 0), MAX_TIMEOUT_MS));
    return () => clearTimeout(id);
  }, [start, duration, now]);

  return start ? runningStatusAt({ startDateTime: start, duration }, now) : "yetToRun";
}
